/**
 * @generated SignedSource<<12b971c95afc9ae2f919c29d33a2b100>>
 * @relayHash cda0f807c9e2dedb44952b0ec05dedfd
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ferrum/362.0.0-2022-04-25T22:46:06.901Z/fetchUserMetadataQuery

import { ConcreteRequest, Query } from 'relay-runtime';
export type fetchUserMetadataQuery$variables = {
  email?: string | null;
};
export type fetchUserMetadataQuery$data = {
  readonly viewer: {
    readonly disableCompleteAccountEmail: boolean | null;
    readonly userExistsMetadata: {
      readonly userExists: boolean | null;
      readonly emailOnly: boolean | null;
      readonly hasPassword: boolean | null;
    } | null;
  };
};
export type fetchUserMetadataQuery = {
  variables: fetchUserMetadataQuery$variables;
  response: fetchUserMetadataQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": "",
    "kind": "LocalArgument",
    "name": "email"
  }
],
v1 = {
  "alias": "disableCompleteAccountEmail",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "disableCompleteAccountEmail"
    }
  ],
  "kind": "ScalarField",
  "name": "isEnabled",
  "storageKey": "isEnabled(key:\"disableCompleteAccountEmail\")"
},
v2 = [
  {
    "kind": "Variable",
    "name": "email",
    "variableName": "email"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userExists",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "emailOnly",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasPassword",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "fetchUserMetadataQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "UserExistsMetadataType",
            "kind": "LinkedField",
            "name": "userExistsMetadata",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "fetchUserMetadataQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "UserExistsMetadataType",
            "kind": "LinkedField",
            "name": "userExistsMetadata",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "ferrum/362.0.0-2022-04-25T22:46:06.901Z/fetchUserMetadataQuery",
    "metadata": {},
    "name": "fetchUserMetadataQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "6d867dae546608c43f089a097be1705d";

export default node;
